import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './About.css';
import NavBarShan from '../NavBar/NavBar';
import LoadingLoggedIn from '../Loading/Loading';

class AboutDet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      AboutPageUrl: 'https://my-webpage-node.vercel.app/About/',
      AboutPageData: [],
      Loading: false,
      line1: 'About',
      textAnimationLine1: [],
      editPopUp: false,
      editPopUpData: {},
      error: false,
      errorDetails: '',
      AboutPageEditUrl: 'https://my-webpage-node.vercel.app/About/EditDetails',
      ButtonClicked: false,
      ButtonText: 'Change'
    }
  }

  async componentDidMount() {
    let tempArr1 = []
    this.props.SelectedPage('LoggedInPage', {
      SelectedPage: 1
    })
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      editPopUpData: {}
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    try {
      let Data = await axios.get(this.state.AboutPageUrl);
      this.setState({
        AboutPageData: Data.data,
        Loading: true
      })
    } catch (err) {
      console.log(err)
      this.setState({
        Loading: false
      })
    }
  }

  async ChangeBtnClick() {
    if (!this.state.ButtonClicked) {
      if (this.state.editPopUpData?.about?.trim() !== "") {
        this.setState({
          ButtonClicked: true,
          ButtonText: 'In Progress'
        })
        // await axios.post(this.state.AboutPageEditUrl, this.state.editPopUpData).then((e) => {
        //     if (e?.data.toString() === 'Success') {
        //         this.setState({
        //             ButtonClicked: false
        //         })
        //         window.location.reload();
        //     } else {
        //         this.setState({
        //             error: true,
        //             errorDetails: e?.data,
        //             ButtonClicked: false,
        //             ButtonText: 'Change'
        //         })
        //     }
        // }).catch((e) => {
        //     this.setState({
        //         error: true,
        //         ButtonClicked: false,
        //         ButtonText: 'Change'
        //     })
        //     console.log(e)
        // })
      } else {
        this.setState({
          error: true,
          ButtonClicked: false,
          ButtonText: 'Change',
          errorDetails: 'No Text is Given'
        })
      }
    }
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    return (<>
      <div className='LoggedInCommonDiv'>
        <NavBarShan />
        {this.state.Loading ?
          <div className='LoggedInSideDiv'>
            <div className='AboutHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='AboutAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'AboutAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'AboutAniLetterMouse AboutAniLetter' : 'AboutAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <table className='AboutLoggedInTbl'>
              <thead>
                <tr>
                  <th className='Aboutpd20 AboutLoggedInTblBrd'>ID No</th>
                  <th className='Aboutpd20 AboutLoggedInTblBrd'>About Description</th>
                  <th className='Aboutpd20 AboutLoggedInTblBrd'>Option</th>
                </tr>
              </thead>
              <tbody>
                {this.state.AboutPageData.map((ite, index) => {
                  return (<>
                    <tr>
                      <td className='Aboutpd20 AboutLoggedInTblBrd'>{ite?._id}</td>
                      <td className='Aboutpd20 AboutLoggedInTblBrd'>{ite?.about}</td>
                      <td className='Aboutpd20 AboutEditBtn AboutLoggedInTblBrd' onClick={() => {
                        this.setState({
                          editPopUpData: ite,
                          editPopUp: true
                        })
                      }}>Edit</td>
                    </tr>
                  </>)
                })}
              </tbody>
            </table>
          </div> :
          <LoadingLoggedIn />}
        {this.state.editPopUp ?
          <div className='AboutEditDataPopUpLoggedIn'>
            <div className='HmPgSubDvLgIn'>
              <div className='HmPgSubLgInFstDv'>
                <div className='popUpDivisionHeading'>
                  {this.state.editPopUpData?._id}
                </div>
                <i className={this.state.closeClassName + ' popUpCloseWindow'} onMouseEnter={() => {
                  this.setState({
                    closeClassName: 'fas fa-times-circle'
                  })
                }} onMouseLeave={() => {
                  this.setState({
                    closeClassName: 'far fa-times-circle'
                  })
                }} onClick={() => {
                  this.setState({
                    closeClassName: 'far fa-times-circle',
                    editPopUp: false
                  })
                }}></i>
              </div>
              <div className='AboutPagePopUpDiv1'>
                <div>
                  <div className='AboutPagePopUpHeadDiv'>ID :</div>
                  <div className='AboutPagePopUpContentDiv'>{this.state.editPopUpData?._id}</div>
                </div>
                <div className='AboutPageAboutDivWrapper'>
                  <div className='AboutPagePopUpHeadDiv'>About Description :</div>
                  <textarea className='AboutPagePopUpEditContentDiv' onChange={(e) => {
                    let data = { ...this.state?.editPopUpData, about: e.target.value }
                    this.setState({
                      editPopUpData: data,
                      error: false,
                      errorDetails: ''
                    })
                  }} >{this.state.editPopUpData?.about}</textarea>
                </div>
                <div className='AboutPagePopUpBtnWrapper'>
                  {this.state.error ? <div className='AboutPagePopUpBtnDiv1'>{this.state.errorDetails}</div>
                    : ''}
                  <div className='AboutPagePopUpBtnDiv2' onClick={(e) => {
                    this.ChangeBtnClick()
                  }}>{this.state.ButtonText}</div>
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>

    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AboutDet));